<template>
  <div>
    <v-btn @click="login" :loading="loading"><v-icon left>{{ icons.mdiFacebook }}</v-icon> {{ $t('auth.SignInWithFacebookButton') }}</v-btn>
    <login-failed-dialog v-if="showLoginFailedDialog" :show="showLoginFailedDialog" @closeDialog="showLoginFailedDialog = false"/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {BASE_API_URL} from '@/store'
  import {fbLogin, initFbSdk} from "@/utils/auth/facebookAuth.js";
  import {mdiFacebook} from '@mdi/js';
  import LoginFailedDialog from '@/components/auth/LoginFailedDialog';

  export default {
    name: "FacebookLogin",
    components: {
      LoginFailedDialog
    },
    data() {
      return {
        loading: false,
        showLoginFailedDialog: false,
        icons: {
          mdiFacebook
        }
      }
    },
    created() {
      this.loadFbSdk();
    },
    computed: {
      ...mapGetters(['client_id']),
    },
    methods: {
      login() {
        this.$store.dispatch('tosScreen', {show: true, acceptAction: this.performLogin, rejectAction: this.rejectTOS});
      },
      rejectTOS() {
        this.$store.dispatch('tosScreen', {show: false});
      },
      async performLogin() {
        let accessToken;
        this.loading = true;
        try {
          const response = await fbLogin({scope: 'public_profile,email'});
          if (response.status === 'connected') {
            accessToken = response.authResponse.accessToken;
          } else {
            this.$store.dispatch('tosScreen', {show: false});
            this.showLoginFailedDialog = true;
          }
        } catch (error) {
          console.error(error)
        }

        if (accessToken) {
          try {
            let response = await this.axios.post(
              `${BASE_API_URL}/api/v2/users/fb-authenticate/?client_id=${this.client_id}`,
              {
                access_token: accessToken,
                locale: this.$i18n.locale
              }
            );
            if (response.data) {
              await this.$store.dispatch('userAuthenticate', {access_token: response.data.access_token});
              if (this.$store.getters.isAuthenticated) {
                this.$store.dispatch('tosScreen', {show: false});
                if (this.$store.getters.isOpenIdProvider) {
                  this.$router.push({name: 'openid'});
                } else {
                  this.$router.push({name: 'home'})
                }
              }
            }
          } catch (error) {
            console.error('error: ', error)
          }
        }
        this.loading = false;
      },
      async loadFbSdk() {
        try {
          await initFbSdk();
        } catch (error) {
          console.error('error loading Facebook SDK');
          throw error
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  $color-facebook: #3b55a0;
  .v-btn {
    font-family: Helvetica, Arial, sans-serif;
    font-weight: bold;
    letter-spacing: .25px;
    text-transform: none;
    color: #fff;
    background-color: lighten($color-facebook, 1%) !important;
    &:hover {
      background-color: lighten($color-facebook, 5%);
    }
    ::v-deep .v-icon--left {
      height: 26px;
      width: 26px;
    }
  }
</style>
